import React from 'react';
import { Users } from 'lucide-react';

const About = () => {
  return (
    <section id="par-mums" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Image */}
          <div className="relative px-4 lg:px-0">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://customer-assets-eiarnc6j.emergentagent.net/job_window-care/artifacts/c7r12e6s_IMG_1428.webp"
                alt="Professional team"
                className="w-full h-[350px] sm:h-[450px] md:h-[600px] object-cover"
              />
            </div>
            
            {/* Decorative element - hidden on mobile */}
            <div className="hidden lg:block absolute -bottom-6 -right-6 w-48 h-48 bg-sky-500 rounded-2xl -z-10"></div>
          </div>

          {/* Right - Content */}
          <div className="space-y-8">
            <div>
              <div className="inline-flex items-center space-x-2 px-4 py-2 bg-sky-100 text-sky-700 rounded-full text-sm font-medium mb-4">
                <Users className="w-4 h-4" />
                <span>Par mums</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Kas mēs esam?
              </h2>
              <div className="space-y-4 text-lg text-gray-600 leading-relaxed">
                <p>
                  <strong className="text-gray-900">SIA "Tīrīšana"</strong> ir uzņēmums, kas specializējas kvalitatīvā iekšpuses un ārpuses logu tīrīšanā. Mēs strādājam pēc vienkārša principa — darīt darbu rūpīgi un atbildīgi, it kā to darītu sev.
                </p>
                <p>
                  Mūsu mērķis ir nodrošināt tīrus, spīdīgus logus bez švīkām, radot patīkamu un sakoptu vidi gan mājās, gan darba vietā. Piedāvājam pakalpojumus privātpersonām, kā arī uzņēmumiem visā Latvijā.
                </p>
              </div>
            </div>

            {/* Guarantee Box */}
            <div className="bg-sky-50 border-2 border-sky-200 rounded-xl p-6">
              <h3 className="font-bold text-gray-900 text-xl mb-3">Mēs garantējam:</h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start space-x-2">
                  <span className="text-sky-500 font-bold">✓</span>
                  <span>Rūpīgu un kvalitatīvu darbu</span>
                </li>
                <li className="flex items-start space-x-2">
                  <span className="text-sky-500 font-bold">✓</span>
                  <span>Elastīgu pieeju un ērtu pieteikšanos</span>
                </li>
                <li className="flex items-start space-x-2">
                  <span className="text-sky-500 font-bold">✓</span>
                  <span>Draudzīgu un uzticamu sadarbību</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
